import apiClient from "../../services/api-client";
import { useMutation } from "@tanstack/react-query";

export const postContactUsApi = (data) => {
  return apiClient({
    method: "POST",
    url: "/v1/contacts",
    data,
  });
};

export const usePostContactUs = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};
  return useMutation(postContactUsApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        message: res.message || "",
      });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        data: error.response.data,
        message: error.message,
      });
    },
  });
};
